import {
  useQuery,
  type UseQueryOptions,
  type QueryKey,
  type QueryFunction,
} from "@tanstack/react-query";

// Define a type for the configuration, allowing all standard UseQueryOptions
// except queryKey and queryFn, which will be passed directly.
export type AppQueryConfig<
  TQueryFnData = unknown,
  TError = Error,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey
> = Omit<UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;

export function useAppQuery<
  TQueryFnData = unknown,
  TError = Error,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey
>(
  queryKey: TQueryKey,
  queryFn: QueryFunction<TQueryFnData, TQueryKey>,
  config?: AppQueryConfig<TQueryFnData, TError, TData, TQueryKey>
) {
  return useQuery({ queryKey, queryFn, ...config });
}